export default "__VITE_ASSET__Hf9TE3uM__"